import React from 'react';

import DefaultSolutionTemplate from './default-solution-template';
import SectionHero from '../components/SectionHero';

const StructuredContentSolutionTemplate = (props) => (
  <DefaultSolutionTemplate {...props}>
    <SectionHero
      title="Create once, publish everywhere"
      description="GraphCMS gives you all the tools you need to define clearly structured content into models that can be delivered via API to all digital frontends"
    />
  </DefaultSolutionTemplate>
);

export default StructuredContentSolutionTemplate;
